<template>
  <div>
    <!-- =================================Loading ======================================================= -->
    <div
      style="margin: 0"
      class="loading-waiting"
      v-bind:style="{ display: finish == true ? 'none' : '' }"
    >
      <div>
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
        <div class="load-wrapp">
          <div class="load-6">
            <div class="letter-holder">
              <div class="l-1 letter">l</div>
              <div class="l-2 letter">o</div>
              <div class="l-3 letter">a</div>
              <div class="l-4 letter">d</div>
              <div class="l-5 letter">i</div>
              <div class="l-6 letter">n</div>
              <div class="l-7 letter">g</div>
              <div class="l-8 letter">.</div>
              <div class="l-9 letter">.</div>
              <div class="l-10 letter">.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- =================================Loading ======================================================= -->
    <v-container fluid>
      <div>
        <v-row>

          <v-col
            cols="12"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;">
            <h3 style="font-weight: 700" class="font_style">Customer Manage</h3>
            <v-spacer></v-spacer>
          </v-col>

          <template>
            <v-col cols="6">
              <v-card style="padding: 1px;">
                <v-card-title style="display: block">
                  <div class="d-flex" style="align-items: center;justify-content: space-between;"> 
                  <v-icon style="font-size: 28px;padding:5px;color:white;background-color:#3BB8C6">mdi-account</v-icon>
                  <label style="font-size: 1.2vw;text-align:right">Count Customer</label>
                  </div>
                  <v-spacer></v-spacer>
                  <div style="font-size: 1.2vw;text-align: right;font-weight:700">{{ count }}</div>
                </v-card-title>
              </v-card>
            </v-col>

            <v-col cols="6">
              <v-card style="padding: 1px;">
                <v-card-title style="display: block">
                  <div class="d-flex" style="align-items: center;justify-content: space-between;"> 
                  <v-icon style="font-size: 28px;padding:5px;color:white;background-color:#3BB8C6">mdi-account-supervisor</v-icon>
                  <label style="font-size: 1.2vw;text-align:right">Total Customer</label>
                  </div>
                  <v-spacer></v-spacer>
                  <div style="font-size: 1.2vw;text-align: right;font-weight:700">{{ convert_digit(total_page)}}</div>
                </v-card-title>
              </v-card>
            </v-col>
          </template>

          <v-col cols="12">
            <v-card>

              <v-card-title>
                <div class="d-flex" style="justify-content: space-between;align-items: center;width: 100%;">
                  <div >
                    <a
                      class="btn refresh-btn font_style"
                      color="primary"
                      @click="refreshData()"
                      style="font-size:13px"
                    >
                      Refresh:
                      <v-icon black style="font-size:14px">mdi-refresh</v-icon>
                    </a>                
                  </div>
                  <v-spacer></v-spacer>
                
                  <div style="display: flex; justify-content: space-between;margin-right:5px;color:gray">
                    <div>
                      <v-form
                      style="display: flex; align-items: center"
                      class="search-area font_style"
                      @submit.prevent="searchWord()" >
                      <v-text-field
                        v-model="search"
                        label="Cus No, Cus Name"
                        single-line
                        hide-details
                        autocomplete="off"
                        style="width: 480px"
                      ></v-text-field>
                        <v-btn color="primary" type="submit" style="font-size: 12px">
                          Search
                          <v-icon right dark> mdi-magnify </v-icon>
                        </v-btn>
                        <div style="width: 10px"></div>
                      </v-form>
                    </div>               
                  </div>
                </div>
                <v-spacer></v-spacer>
              </v-card-title>
              
              <v-card-text id="customer-manage" >
                <v-btn
                  color="teal"
                  dark
                  style="width: 150px; font-size: 12px; font-weight: 600"
                  @click="Export_AllFile()"
                  text>
                  Export All File
                </v-btn>

                <label style="font-size: 12px; float: right;padding-top:15px">page : {{ page}}</label>

                <!-- --------------------------------------table--------------------------------------------- -->
                <div class="table-sum-cus">
                  <v-simple-table
                    class="table_in_sum_customer"
                    fixed-header
                    height="600px"
                    style="border-top: 1px solid #ABAFAB">

                    <thead>
                      <tr v-if="biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'">
                        <th
                          v-for="header in pivotHeaders"
                          :key="header.value"
                          style="text-align: center; padding: 0;height:80px; font-weight:700;z-index:1"
                          :style="{ 'background-color': header.color , 
                            'border-right': header.value == 'Billing' || header.value == 'Payment' ? '0px' : '1px solid #ABAFAB' }"
                        >
                          <div style="height:40px;align-items: center;
                              display: flex;font-size:14px;padding:0px"
                              v-bind:style="{ 'border-right':header.value == 'Billing' || header.value == 'Payment' ? '1px solid #ABAFAB' : '0px' ,
                              'width':header.value == 'Billing' ? '950px' : '300px',
                              'width':header.value == 'Payment' ? '751px' : '',
                              'justify-content':header.value == 'Cus No.'? 'left' : 'center' }"
                          > 
                            {{ header.value }}
                          </div>
                          <td v-for="value in header.sub"
                            :colspan="value.colspan"
                            style="text-align: center;width:360px"
                            :key="value.value"
                          >            
                            <div 
                              style="width:auto;height:40px;text-align: center;margin:auto;  
                                align-items: center;
                                display: flex;
                                justify-content: center;
                                border-right:1px solid #ABAFAB;
                                border-top:1px solid #ABAFAB;
                                border-bottom:1px solid #ABAFAB;
                                "
                                :style="{ 'background-color': value.color,
                                'width': value.value == 'เอกสารประกอบวางบิล' || value.value == 'ข้อมูลอื่นๆ'? '350px' : '200px'}" >
                              {{value.value}}
                            </div>   
                          </td>
                        </th>
                      </tr>
                      <tr v-else>
                        <th
                          v-for="header in pivotHeadersJV"
                          :key="header.value"
                          style="text-align: center; padding: 0;height:80px;font-weight:700;z-index:1"
                          :style="{ 'background-color': header.color , 
                            'border-right': header.value == 'Billing' || header.value == 'Payment' ? '0px' : '1px solid #ABAFAB' }"
                        >
                          <div style="height:40px;align-items: center;
                              display: flex;font-size:14px;padding:0px"
                              v-bind:style="{ 'border-right':header.value == 'Billing' || header.value == 'Payment' ? '1px solid #ABAFAB' : '0px' ,
                              'width':header.value == 'Billing' ? '950px' : '300px',
                              'width':header.value == 'Payment' ? '751px' : '',
                              'justify-content':header.value == 'Cus No.'? 'left' : 'center' }"
                          > 
                            {{ header.value }}
                          </div>
                          <td v-for="value in header.sub"
                            :colspan="value.colspan"
                            style="text-align: center;width:360px"
                            :key="value.value"
                          >            
                            <div 
                              style="width:auto;height:40px;text-align: center;margin:auto;  
                                align-items: center;
                                display: flex;
                                justify-content: center;
                                border-right:1px solid #ABAFAB;
                                border-top:1px solid #ABAFAB;
                                border-bottom:1px solid #ABAFAB;
                                "
                                :style="{ 'background-color': value.color,
                                'width': value.value == 'เอกสารประกอบวางบิล' || value.value == 'ข้อมูลอื่นๆ'? '350px' : '200px'}" >
                              {{value.value}}
                            </div>   
                          </td>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="item_row in datalist" :key="item_row.id" class="hover-td">
                        <td style="pagging-left:10px;padding:0;vertical-align: middle;">
                          <div class="d-flex"  style="align-items: center;width:200px;padding-left:20px;text-align:left">
                            {{item_row.customer_no}}
                          </div>                     
                        </td>
                        <td style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div style="width:200px;padding-left:10px;text-align:left">{{item_row.customer_name}}</div>                     
                        </td>
                        <td style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div v-if="biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'" style="width:200px;padding-left:10px;text-align:left">{{item_row.financial_name}}</div>
                          <input
                              v-else
                              type="text"
                              class="style-chooser form-control"
                              :disabled=" role_status == 'viewer' "
                              v-model="item_row.financial_name"
                              placeholder="Finance Officer"
                              @change="updateCustomer(item_row)"
                          style="font-size:13px; width:220px; margin:5px"/>
                        </td>
                        <td v-if="biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'" style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div class="d-flex"  style="align-items: center;width:200px;padding-left:20px;text-align:left">
                            {{item_row.financial_id}}
                          </div>
                        </td>
                        <td style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div style="width:200px;text-align:center">{{item_row.credit_name}}</div>
                        </td>
                        <!-- status -->
                        <td v-if="biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'" style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div style="width:150px;">
                            <v-chip style="width:100px;height:45px" color="success" label outlined v-if="item_row.active=='1'">
                                Active
                            </v-chip>
                            <v-chip style="width:100px;height:45px" color="orange" label outlined v-if="item_row.active=='0'">
                                Non Active
                            </v-chip></div>
                        </td>
                        <td v-if="biz_name !== 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'" style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div style="width:180px;text-align:left">
                            <select
                              class="style-chooser form-control"
                              v-model="item_row.customer_criteria"
                              :disabled=" role_status == 'viewer' "
                              style="font-size:13px;width:140px;margin:auto"
                              @change="updateCustomer(item_row)"
                            >
                              <option value=""></option>
                              <option value="01 - Normal">01 - Normal</option>
                              <option value="02 - Critical">02 - Critical</option>
                            </select>
                          </div>
                        </td>
                        <td style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div style="width:260px; text-align:left;">
                            <select
                                style="font-size:13px; width: 220px; margin: auto;"
                                class="style-chooser  form-control"
                                v-model="item_row.online_payment"
                                :disabled=" role_status == 'viewer' "
                                @change="updateCustomer(item_row)">
                                <!-- <option value="true">YES</option>
                                <option value="false">NO</option>
                                <option value="Pending">Pending</option> -->
                                <option value=""></option> 
                                <option value="Online Billing - Online Payment">Online Billing - Online Payment</option>
                                <option value="Online Billing - Offline Payment">Online Billing - Offline Payment</option>
                                <option value="Offline Billing - Online Payment">Offline Billing - Online Payment</option>
                                <option value="Offline Billing - Offline Payment">Offline Billing - Offline Payment</option>
                            </select>
                          </div>                    
                        </td>
                        <!-- Contact -->
                        <td style="padding:0;border-right:1px solid #ABAFAB;vertical-align: middle;">
                          <div style="width:200px;text-align:center">
                             <v-btn
                              color="primary"
                              class="mb-2"
                               @click="
                                (dialog_contact = true) , open_contact(item_row)
                              "
                            >
                              Contact
                            </v-btn>
                          </div>
                        </td>
                        <td class="td_sub_value" style="padding: 0;" >
                          <div class="d-flex" style="align-items: center;">
                            <div style="width:200px">
                              <input
                                type="text"
                                class="style-chooser form-control"
                                :disabled=" role_status == 'viewer' "
                                v-model="item_row.billing_due"
                                placeholder="Due Type"
                                @change="updateCustomer(item_row)"
                                style="font-size:13px;width:95%;margin:auto"/>
                            </div>
                            
                            <div style="width:200px;text-align:center">
                              <v-btn
                                color="primary"
                                class="mb-2"
                                @click="dialog_plan_billing = true , yearList() , plan_billing(item_row)"
                              >
                                Plan
                              </v-btn>
                            </div>

                            <div style="width:200px; text-align:left;">
                              <select
                                  style="font-size:13px; width: 180px; margin: auto;"
                                  class="style-chooser  form-control"
                                  :disabled=" role_status == 'viewer' "
                                  v-model="item_row.billing_type"
                                  @change="updateCustomer(item_row)">
                                  <option value=""></option>
                                  <option value="Mail">Mail</option>
                                  <option value="ปณ.">ปณ.</option>
                                  <option value="Mail+ปณ.">Mail+ปณ.</option>
                                  <option value="Messenger">Messenger</option>
                                  <option value="Sale">Sale</option>
                                  <option value="online payment">online payment</option>
                                  <option v-if="biz_name !== 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'" value="Billing RPT">Billing RPT</option>
                                  <option v-if="biz_name !== 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'" value="JV">JV</option>
                              </select>
                            </div>

                            <div style="width:200px;padding-left:10px;text-align:left">
                              <select
                                style="font-size:13px;width: 150px;text-align: center;margin: auto;padding: 0;"
                                class="style-chooser  form-control"
                                :disabled=" role_status == 'viewer' "
                                v-model="item_row.billing_after_checking"
                                @change="updateCustomer(item_row)">
                                  <option value=""></option>
                                  <option value="true">YES</option>
                                  <option value="false">NO</option>
                              </select>
                            </div>

                            <div style="width:200px;padding-left:10px;text-align:left">
                              <select
                                style="font-size:13px;width: 150px;text-align: center;margin: auto;padding: 0;"
                                class="style-chooser  form-control"
                                :disabled=" role_status == 'viewer' "
                                v-model="item_row.billing_checking"
                                @change="updateCustomer(item_row)">
                                  <option value=""></option>
                                  <option value="true">YES</option>
                                  <option value="false">NO</option>
                              </select>
                            </div>

                            <div style="width:310px;margin:auto;margin-block: 10px;"> 
                              <v-autocomplete
                                :items="archive_list"
                                v-model="item_row.billing_document"
                                :disabled=" role_status == 'viewer' "
                                chips
                                multiple
                                rounded
                                label="เอกสารประกอบวางบิล"
                                deletable-chips
                                @change="updateCustomer_document(item_row)"
                              ></v-autocomplete>                    

                              <b-textarea
                                rows="1"
                                max-rows="100" 
                                v-bind:style="{ display: item_row.other == 'close'? 'none' : '' }"                                    
                                v-model="item_row.remark"
                                placeholder="โปรดระบุข้อมูล อื่นๆ"
                                style="padding-top:0px;margin-top:0px;margin:auto;width:95%"
                                @change="remark_text(item_row);"                            
                              ></b-textarea>            
                            </div>

                            <div style="width:350px">
                              <b-textarea
                                placeholder="ข้อมูลอื่นๆ"
                                :disabled=" role_status == 'viewer' "
                                v-model="item_row.billing_contact"
                                rows="2"
                                max-rows="100" 
                                style="font-size:13px;"
                                @change="updateCustomer(item_row)"
                              ></b-textarea>
                            </div>
                          </div>
                        </td>

                        <td class="td_sub_value" style="padding: 0;" >
                          <div class="d-flex">
                            <div style="width:200px; text-align:center; align-items: center; justify-content: center; margin: auto;">
                              <v-btn
                                color="primary"
                                class="mb-2"
                                @click="dialog_plan_payment = true , yearList() , plan_payment(item_row)"
                              >
                                Plan
                              </v-btn>
                            </div>

                            <div style="width:200px; text-align:center; align-items: center; justify-content: center; margin: auto;">

                              <select
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option v-for="option in bizOptions" :key="option" :value="option">
                                  {{ option }}
                                </option>
                              </select>

                              <!-- <select
                                v-if="biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                  <option value=""></option>
                                  <option value="KBANK579">KBANK579</option>
                                  <option value="KBANK861">KBANK861</option>
                                  <option value="KBANK035">KBANK035</option>
                                  <option value="KBANK199">KBANK199</option>
                                  <option value="KTB856">KTB856</option>
                                  <option value="BBL205">BBL205</option>
                                  <option value="BBL785">BBL785</option>
                                  <option value="QR_CODE">QR CODE</option>
                                  <option value="SCB376">SCB376</option>
                                  <option value="SCB009">SCB009</option>
                                  <option value="KTB395">KTB395</option>
                                  <option value="KTB184">KTB184</option>
                                  <option value="TMB958">TMB958</option>
                                  <option value="BAY778">BAY778</option>
                                  <option value="GSB491">GSB491</option>
                                  <option value="CHQ">CHQ</option>
                                  <option value="FACTORING">FACTORING</option>
                                  <option value="TBANK064">TBANK064</option>
                                  <option value="Bill Payment - SCB">
                                    Bill Payment - SCB
                                  </option>
                                  <option value="Bill Payment - KBANK">
                                    Bill Payment - KBANK
                                  </option>
                                  <option value="Bill Payment - BBL">
                                    Bill Payment - BBL
                                  </option>
                              </select>

                            
                              <select
                                v-else-if="biz_name == 'บริษัท ดิจิตอล เฮลท์ อินฟอร์เมติคส์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB791">KTB791</option>
                                <option value="KTB224">KTB224</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท เน็กซ์ เจน ชอป จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB671">KTB671</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท เอ็กเซลเลนท์ เฮลท์ แพลตฟอร์ม จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB756">KTB756</option>
                                <option value="KTB690">KTB690</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ทุณทรัพย์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB697">KTB697</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท วัน ออเทน จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK194">ASOK194</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท เน็กซ์พาย จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK172">ASOK172</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ทอล์คทูมี จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK919">ASOK919</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ดี โซลูชั่น คลาวด์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK092">ASOK092</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ซอฟต์เวย์ คอนซัลติง จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB783">KTB783</option>
                                <option value="KTB216">KTB216</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท แชท มี จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB635">KTB635</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ไอเน็กซ์ บรอดแบนด์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK113">ASOK113</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท โอเพ่นแลนด์สเคป จำกัด (มหาชน)'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK184">ASOK184</option>
                                <option value="KTB264">KTB264</option>
                                <option value="TMB499">TMB499</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท วัน อีเมล จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="TMB416">TMB416</option>
                                <option value="ASOK024">ASOK024</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท แมนดาลา คอมมูนิเคชั่น จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK529">ASOK529</option>
                                <option value="ASOK469">ASOK469</option>
                                <option value="BBL288">BBL288</option>
                                <option value="TBANK276">TBANK276</option>
                                <option value="TMB440">TMB440</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท เวอร์ชวล การ์เด้น รูม จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB590">KTB590</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท บาร์เรล ออฟ เอคเซลเลนซ์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB816">KTB816</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท อินเทลลิจิสต์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK277">ASOK277</option>
                                <option value="GSB824">GSB824</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท โมบิลิสต์ เทค จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB897">KTB897</option>
                                <option value="KTB305">KTB305</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ไทย วิธโฮลดิ้งแทคซ์ เซอร์วิส จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK243">ASOK243</option>
                                <option value="ASOK781">ASOK781</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ออลเดมิคส์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB651">KTB651</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท วัน ดีซี จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK264">ASOK264</option>
                                <option value="KTB264">KTB264</option>
                                <option value="TMB424">TMB424</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท วัน อินโนเวทีฟ ดีไซน์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK046">ASOK046</option>
                                <option value="ASOK140">ASOK140</option>
                                <option value="KTB264">KTB264</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ธิงส์ คอนเนกซ์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK035">ASOK035</option>
                                <option value="KTB264">KTB264</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ทูมอโร่สไมล์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK217">ASOK217</option>
                                <option value="KTB003">KTB003</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ไอเน็ต แมเนจด์ เซอร์วิสเซส จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK983">ASOK983</option>
                                <option value="SCB509">SCB509</option>
                              </select>

                            
                              <select
                                v-else-if="biz_name == 'บริษัท ไอรีครูท จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK105">ASOK105</option>
                                <option value="ASOK981">ASOK981</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ไทย ดอท คอม เพย์เมนท์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK114">ASOK114</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ดิจิทัล เฮลท์แคร์ โซลูชันส์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK897">ASOK897</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ทรานฟอร์ม ยู จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK612">ASOK612</option>
                                <option value="TMB481">TMB481</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ไทยไอเด็นติตี้ส์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK673">ASOK673</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท วัน จีโอ เซอร์เวย์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK105">ASOK105</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท วัน อิเล็กทรอนิกส์ บิลลิ่ง จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK224">ASOK224</option>
                                <option value="ASOK848">ASOK848</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท ดาต้า เน็กซ์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK098">ASOK098</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท อะกรินโน่ เทค แอนด์ เซอร์วิสเซส จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK128">ASOK128</option>
                              </select>

                            
                              <select
                                v-else-if="biz_name == 'บริษัท มาย แพลตฟอร์ม จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK019">ASOK019</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท บลิชเทค จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK041">ASOK041</option>
                                <option value="ASOK033">ASOK033</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท เอทรอน อินโนเวชั่น จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK546">ASOK546</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ไทย ดอท คอม จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK554">ASOK554</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท วันสเปซ คอร์ปอเรชั่น จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK538">ASOK538</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท วัน สมาร์ท แอคเซส จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK474">ASOK474</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท แมเนจ เอไอ โซลูชั่น จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK737">ASOK737</option>
                              </select>

                              
                              <select
                                v-else-if="biz_name == 'บริษัท วัน เซ็นทริค จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="ASOK520">ASOK520</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท ไอเน็ต รีท แมเนจเม้นท์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB017">KTB017</option>
                              </select>

                             
                              <select
                                v-else-if="biz_name == 'บริษัท พัฒนาเครือข่ายอิเล็กทรอนิกส์ จำกัด'"
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KBANK448">KBANK448</option>
                                <option value="KTB857">KTB857</option>
                                <option value="KTB682">KTB682</option>
                              </select>

                              
                              <select
                                v-else
                                class="style-chooser form-control"
                                v-model="item_row.payment_type"
                                :disabled=" role_status == 'viewer' "
                                style="font-size:12px;width:180px;margin:auto"
                                @change="updateCustomer(item_row)"
                              >
                                <option value=""></option>
                                <option value="KTB340">KTB340</option>
                                <option value="KTB615">KTB615</option>
                                <option value="UOB185">UOB185</option>
                                <option value="BAAC263">BAAC263</option>
                              </select> -->
                            </div>

                            <div style="width:350px;">
                              <b-textarea
                                placeholder="ข้อมูลอื่นๆ"
                                v-model="item_row.payment_contact"
                                rows="2"
                                max-rows="100" 
                                style="font-size:13px;"
                                :disabled=" role_status == 'viewer' "
                                @change="updateCustomer(item_row)"
                              ></b-textarea>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                  </v-simple-table>
                  <div class="d-flex" style=" justify-content:end;margin-top: 20px">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          margin-right: 10px;
                        "
                      >
                        Items per page:
                      </div>
                      <select
                        style="width: 80px; margin-right: 20px"
                        class="style-chooser"
                        v-model="item_per_page_count"
                        @change="item_per_page()"                      
                      >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="300">300</option>
                        <option value="500">500</option>
                      </select>
                    <v-pagination                 
                      v-model="page"
                      :length="count_page"
                      :total-visible="7"
                      @input="pageChange()"
                    ></v-pagination>
                    </div>

                </div>
              </v-card-text>

            </v-card>
          </v-col>

          <!---------------------------------------- Dialog Contact -------------------------------------------------->
          <v-dialog v-model="dialog_contact" persistent max-width="1260px">
            <v-card>
              <v-card-title class="text-h5 tab-tilte-dialog">
                <span
                  class="text-h5"
                  style="
                      font-family: 'Bai_Jamjuree' !important;
                  "
                  >Contact - ข้อมูลติดต่อ</span
                >
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog_contact = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <div class="cover-table">
                      <div class="table-invoice" style="position: relative">
                        <v-data-table
                          :headers="herders_contact"
                          :items="datalist_contact"
                          :hide-default-footer="true"
                          class="table_in_book1"
                          fixed-header
                          item-key="customer_type"
                          id="invoice_book_1"
                        >
                          <template v-slot:[`item.customer_type`]="{ item }">
                            {{ item.customer_type }}
                          </template>

                          <template v-slot:[`item.contact_name`]="{ item }">
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.contact_name"
                            />
                          </template>
                          <template v-slot:[`item.contact_tel`]="{ item }">
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.contact_tel"
                            />
                          </template>
                          <template v-slot:[`item.contact_email`]="{ item }">
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.contact_email"
                            />
                          </template>
                          <template v-slot:[`item.contact_remark`]="{ item }">
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.contact_remark"
                            />
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </v-card-text>
                  
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="#7EC069"
                      class="white--text"
                      @click="save_contact()"
                    >
                      Save
                    </v-btn>
                    <v-btn
                      color="#EC5F59"
                      class="white--text"
                      @click="dialog_contact = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-card>
          </v-dialog>
          <!---------------------------------------- End Dialog Contact -------------------------------------------------->

          <!---------------------------------------- Dialog Billing Plan -------------------------------------------------->
          <v-dialog v-model="dialog_plan_billing" persistent max-width="485px">
            <v-card>
              <v-card-title class="text-h5 tab-tilte-dialog">
                <span
                  class="text-h5"
                  style="
                      font-family: 'Bai_Jamjuree' !important;
                  "
                  >Billing Due Date</span
                >
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog_plan_billing = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Customer No. :</span>
                  </v-col>
                  <v-col cols="8">
                    <span>{{customer_no_dialog}}</span>
                  </v-col>
                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Customer Name :</span>
                  </v-col>
                  <v-col cols="8">
                    <span>{{customer_name_dialog}}</span>
                  </v-col>

                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Year :</span>
                  </v-col>
                  <v-col cols="8">
                    <select class="form-control" style="width:40%;" v-model="selectedYear" @change="fillter_plan_billing()">
                      <option value="" disabled selected>Select a year</option>
                      <option v-for="year in yearlist" :value="year" :key="year">{{ year }}</option>
                    </select>
                  </v-col>

                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Date :</span>
                  </v-col>
                  <v-col cols="8">
                    <select class="form-control" style="width:40%;" v-model="selectedDay" @change="fillter_plan_billing()">
                      <option value="" disabled selected>Select a day</option>
                      <option v-for="day in days" :value="day" :key="day">{{ day }}</option>
                    </select>
                  </v-col>

                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Postpone :</span>
                  </v-col>
                  <v-col cols="8">
                    <select class="form-control" style="width:40%;" v-model="postpone" @change="fillter_plan_billing()">
                      <option value="" disabled selected>Select</option>
                      <option value="เลื่อนเข้า">เลื่อนเข้า</option>
                      <option value="เลื่อนออก">เลื่อนออก</option>
                    </select>
                  </v-col>
                </v-row>
              </v-container>

              <!-----------------------table---------------------------->
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <div class="cover-table">
                      <div class="table-invoice" style="position: relative">
                        <v-data-table
                          :headers="herders_billing_payment"
                          :items="datalist_plan"
                          :hide-default-footer="true"
                          class="table_in_book1"
                          :items-per-page="12"
                          item-key="period"
                          id="invoice_book_1"
                          height="360px"
                        >

                          <template v-slot:[`item.date`]="{ item }">
                            <div class="d-flex">
                              <input
                                type="date"
                                class="form-control"
                                v-model="item.date"
                                placeholder="Select Date"
                              />
                              <button
                                class="btn"
                                style="font-size: 18px"
                                @click="clearDate(item)"
                              >
                                x
                              </button>
                            </div>
                          </template>

                        </v-data-table>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#7EC069"
                  class="white--text"
                  :disabled="selectedYear == '' || selectedDay == '' || postpone == ''"
                  @click="save_plan('billingduedate')"
                >
                  Save
                </v-btn>
                <v-btn
                  color="#EC5F59"
                  class="white--text"
                  @click="dialog_plan_billing = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
              
            </v-card>
          </v-dialog>
          <!---------------------------------------- End Dialog Billing Plan -------------------------------------------------->

          <!---------------------------------------- Dialog Payment Plan -------------------------------------------------->
          <v-dialog v-model="dialog_plan_payment" persistent max-width="485px">
            <v-card>
              <v-card-title class="text-h5 tab-tilte-dialog">
                <span
                  class="text-h5"
                  style="
                      font-family: 'Bai_Jamjuree' !important;
                  "
                  >Payment Due Date</span
                >
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog_plan_payment = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Customer No. :</span>
                  </v-col>
                  <v-col cols="8">
                    <span>{{customer_no_dialog}}</span>
                  </v-col>
                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Customer Name :</span>
                  </v-col>
                  <v-col cols="8">
                    <span>{{customer_name_dialog}}</span>
                  </v-col>

                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Year :</span>
                  </v-col>
                  <v-col cols="8">
                    <select class="form-control" style="width:40%;" v-model="selectedYear" @change="fillter_plan_billing()">
                      <option value="" disabled selected>Select a year</option>
                      <option v-for="year in yearlist" :value="year" :key="year">{{ year }}</option>
                    </select>
                  </v-col>

                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Date :</span>
                  </v-col>
                  <v-col cols="8">
                    <select class="form-control" style="width:40%;" v-model="selectedDay" @change="fillter_plan_billing()">
                      <option value="" disabled selected>Select a day</option>
                      <option v-for="day in days" :value="day" :key="day">{{ day }}</option>
                    </select>
                  </v-col>

                  <v-col cols="4" style="text-align:right;">
                    <span class="font-weight-bold" >Postpone :</span>
                  </v-col>
                  <v-col cols="8">
                    <select class="form-control" style="width:40%;" v-model="postpone" @change="fillter_plan_billing()">
                      <option value="" disabled selected>Select</option>
                      <option value="เลื่อนเข้า">เลื่อนเข้า</option>
                      <option value="เลื่อนออก">เลื่อนออก</option>
                    </select>
                  </v-col>
                </v-row>
              </v-container>

              <!-----------------------table---------------------------->
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <div class="cover-table">
                      <div class="table-invoice" style="position: relative">
                        <v-data-table
                          :headers="herders_billing_payment"
                          :items="datalist_plan"
                          :hide-default-footer="true"
                          class="table_in_book1"
                          :items-per-page="12"
                          item-key="period"
                          id="invoice_book_1"
                          height="360px"
                        >
                          <template v-slot:[`item.date`]="{ item }">
                            <div class="d-flex">
                              <input
                                type="date"
                                class="form-control"
                                v-model="item.date"
                                placeholder="Select Date"
                              />
                              <button
                                class="btn"
                                style="font-size: 18px"
                                @click="clearDate(item)"
                              >
                                x
                              </button>
                            </div>
                          </template>

                        </v-data-table>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#7EC069"
                  class="white--text"
                  :disabled="selectedYear == '' || selectedDay == '' || postpone == ''"
                  @click="save_plan('paymentduedate')"
                >
                  Save
                </v-btn>
                <v-btn
                  color="#EC5F59"
                  class="white--text"
                  @click="dialog_plan_payment = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
              
            </v-card>
          </v-dialog>
          <!---------------------------------------- End Dialog Payment Plan -------------------------------------------------->

        </v-row>
        
      </div>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import Vue from "vue";
import TextareaAutosize from "vue-textarea-autosize";
Vue.use(TextareaAutosize);
import "carbon-components/css/carbon-components.min.css";
import "carbon-components/css/carbon-components.css";
// import { BModal, VBModal } from "bootstrap-vue";
import Swal from "sweetalert2";
export default {
  data: () => ({
    page: 1,
    count: 50,
    count_page: 1,
    total_page: 100,
    datalist: [],
    archive_list: ["PO", "สัญญา", "QT", "Report", "อื่นๆ"],
    search: "",
    customer_name: "",
    active: "",
    status_customer:"",
    customer_criteria:"",
    credit_name: "",
    customer_no: "",
    customer_email: "",
    billing_due: "",
    billing_contact: "",
    finance_name: "",
    billing_type:"",
    billing_after_checking: "",
    billing_checking: "",
    billing_document: "",
    payment_due: "",
    payment_contact: "",
    payment_type: "",
    con_cus_no: "",
    con_cus_name: "",
    emptyFinance:[],
    search_customer_name: null,
    dialog_contact: false,
    dialog_plan_billing: false,
    dialog_plan_payment: false,
    datalist_contact: [],
    datalist_plan: [],
    selectedYear: '',
    selectedDay: '',
    customer_no_dialog: '',
    customer_name_dialog: '',
    days: Array.from({ length: 31 }, (v, i) => i).slice(1),
    postpone: '',
    startYear: 1990,
    endYear: new Date().getFullYear(),
    yearlist: [],
    herders_contact: [
      {
        text: "Contact Type",
        value: "contact_type",
        width: "200px",
        sortable: true,
        class: "invoice1",
      },
      {
        text: "Contact Name",
        value: "contact_name",
        width: "250px",
        sortable: true,
        align: "center",
      },
      {
        text: "Tel.",
        value: "contact_tel",
        width: "250px",
        sortable: true,
        align: "center",
      },
      {
        text: "Email",
        value: "contact_email",
        width: "250px",
        sortable: true,
        align: "center",
      },
      {
        text: "Remark",
        value: "contact_remark",
        width: "250px",
        sortable: true,
        align: "center",
      },
    ],
    herders_billing_payment: [
      {
        text: "Period",
        value: "month",
        width: "150px",
        sortable: true,
        // align: "center",
        class: "invoice1",
      },
      {
        text: "Due Date",
        value: "date",
        width: "100px",
        sortable: true,
        align: "center",
      },
    ],
    pivotHeaders: [
      { value: "Customer No.", colspan: 1, color: "#FFF6CC !important" },
      { value: "Customer Name.", colspan: 1, color: "#FFF6CC !important" },
      {
        value: "Finance Officer",
        colspan: 1,
        color: "#FFF6CC !important",
      },
      { value: "Finance Id", colspan: 1, color: "#FFF6CC !important" },
      { value: "Credit Term", colspan: 1, color: "#FFF6CC !important" },
      { value: "Status", colspan: 1, color: "#FFF6CC !important" },
      // { value: "Customer criteria", colspan: 1, color: "#FFF6CC !important" },
      { value: "Online Payment", colspan: 1, color: "#FFF6CC !important" },
      { value: "Contact", colspan: 1, color: "#FFF6CC !important" },
      {
        value: "Billing",
        colspan: 2,
        color: "#C2DAD3 !important",
        sub: [
          {
            value: "Due Type",
            colspan: 1,
            color: "#C2DAD3",
            id: 1,
          },
          {
            value: "Billing Due Date",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "วิธีวางบิล",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "วางบิลหลังใช้งาน",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "วางบิลพร้อมใบเสร็จ",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "เอกสารประกอบวางบิล",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "ข้อมูลอื่นๆ",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
        ]
      },
      {
        value: "Payment",
        colspan: 2,
        color: "#E8C46A !important",
        sub: [
          {
            value: "Payment Due Date",
            colspan: 1,
            color: "#E8C46A",
            id: 3,
          },
          {
            value: "ช่องทางการชำระ",
            color: "#E8C46A",
            colspan: 1,
            id: 4,
          },
          {
            value: "ข้อมูลอื่นๆ",
            color: "#E8C46A",
            colspan: 1,
            id: 4,
          },
        ],
      }
    ],
    pivotHeadersJV: [
      { value: "Customer No.", colspan: 1, color: "#FFF6CC !important" },
      { value: "Customer Name.", colspan: 1, color: "#FFF6CC !important" },
      {
        value: "Finance Officer",
        colspan: 1,
        color: "#FFF6CC !important",
      },
      { value: "Credit Term", colspan: 1, color: "#FFF6CC !important" },
      // { value: "Status", colspan: 1, color: "#FFF6CC !important" },
      { value: "Customer criteria", colspan: 1, color: "#FFF6CC !important" },
      { value: "Online Payment", colspan: 1, color: "#FFF6CC !important" },
      { value: "Contact", colspan: 1, color: "#FFF6CC !important" },
      {
        value: "Billing",
        colspan: 2,
        color: "#C2DAD3 !important",
        sub: [
          {
            value: "Due Type",
            colspan: 1,
            color: "#C2DAD3",
            id: 1,
          },
          {
            value: "Billing Due Date",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "วิธีวางบิล",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "วางบิลหลังใช้งาน",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "วางบิลพร้อมใบเสร็จ",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "เอกสารประกอบวางบิล",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
          {
            value: "ข้อมูลอื่นๆ",
            color: "#C2DAD3",
            colspan: 1,
            id: 2,
          },
        ]
      },
      {
        value: "Payment",
        colspan: 2,
        color: "#E8C46A !important",
        sub: [
          {
            value: "Payment Due Date",
            colspan: 1,
            color: "#E8C46A",
            id: 3,
          },
          {
            value: "ช่องทางการชำระ",
            color: "#E8C46A",
            colspan: 1,
            id: 4,
          },
          {
            value: "ข้อมูลอื่นๆ",
            color: "#E8C46A",
            colspan: 1,
            id: 4,
          },
        ],
      }
    ],
    finish: false,
    Alldata: [],
    customer_no_blank: false,
    customer_email_blank: false,
    customer_name_list: [],
    customer_no_list: [],
    item_per_page_count: 50,
    selected: false,
    enabled: false,
    filterlist: [],
    finance_name_list: [],
    biz_id : "",
    biz_name: "",
    bizOptions: []
  }),
  created() {
    this.role_status = localStorage.getItem("role");
    this.biz_id = localStorage.getItem("biz_id");
    this.biz_name = localStorage.getItem("biz_name");
    this.Init();
    this.getDropdown();
    this.getFinance();
  },
  watch: {},
  computed: {},
  methods: {
    getDropdown(){
      let headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };
      this.axios
        .get(
          process.env.VUE_APP_API +
            "/dropdown/bankaccount?biz_id=" + this.biz_id,headers
        )
        .then((response) => {
          if (response.status === 200) {
            // this.finish = true;
            response.data.data.forEach((element) => {
              this.bizOptions.push(element.bank_number)
            });
          }
          
        })
        .catch((error) => {
          if (error) {
            // this.finish = true;
            console.log(error)
          }
        });
    },
    yearList() {
      const years = [];
      for (let i = this.endYear; i >= this.startYear; i--) {
        years.push(i);
      }
      this.yearlist =  years;
    },
    plan_billing(item){
      this.finish = false;
      this.datalist_plan = [];
      this.customer_no_dialog = "";
      this.customer_name_dialog = ""
      this.selectedYear = "";
      this.selectedDay = "";
      this.postpone = "";

      let headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .get(
          process.env.VUE_APP_API +"/customer/billingdue/"+item.customer_no + "?biz_id="+this.biz_id,headers
        )
        .then((response) => {
          this.finish = true;
          let data = response.data.data;
          // console.log(data)

          this.customer_no_dialog = data.customer_no;
          this.customer_name_dialog = data.customer_name;
          this.selectedYear = data.year;
          this.selectedDay = data.day;
          this.postpone = data.postpone;

          data.month_ref.forEach((element => {
            this.datalist_plan.push({
              month : element.month,
              date : this.parseDate(element.date)
            })
          }))

          // this.datalist_plan = data.month_ref;
          
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.finish = true;
            this.$router.push("/login");
          }
        });
    },
    plan_payment(item){
      this.finish = false;
      this.datalist_plan = [];
      this.customer_no_dialog = "";
      this.customer_name_dialog = ""
      this.selectedYear = "";
      this.selectedDay = "";
      this.postpone = "";

      let headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .get(
          process.env.VUE_APP_API +"/customer/paymentdue/"+item.customer_no + "?biz_id="+this.biz_id ,headers
        )
        .then((response) => {
          this.finish = true;
          let data = response.data.data;
          // console.log(data)

          this.customer_no_dialog = data.customer_no;
          this.customer_name_dialog = data.customer_name;
          this.selectedYear = data.year;
          this.selectedDay = data.day;
          this.postpone = data.postpone;
          //this.datalist_plan = data.month_ref;

          data.month_ref.forEach((element => {
            this.datalist_plan.push({
              month : element.month,
              date : this.parseDate(element.date)
            })
          }))
          
          
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.finish = true;
            this.$router.push("/login");
          }
        });
    },
    parseDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    fillter_plan_billing(){
      if(this.selectedYear != "" && this.selectedDay != "" && this.postpone != ""){
        this.finish = false;
        this.datalist_plan = [];
        let headers = {
          headers: {
            Authorization:
              "Bearer " +
              localStorage.getItem("acces_token") +
              "," +
              localStorage.getItem("secret"),
          },
        };

        this.axios
          .get(
            process.env.VUE_APP_API +"/customer/postponedue?year=" + 
            this.selectedYear + 
            "&day=" +
            this.selectedDay +
            "&postpone=" + 
            this.postpone + 
            "&biz_id=" +
            this.biz_id ,headers
          )
          .then((response) => {
            this.finish = true;
            let data = response.data.data;
            //console.log(data)
            //this.datalist_plan = data;

            data.forEach((element => {
            this.datalist_plan.push({
              month : element.month,
              date : this.parseDate(element.date)
            })
          }))
          
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.finish = true;
              this.$router.push("/login");
            }
          });
      }
    },
    clearDate(item){
      item.date = "0001-01-01"
    },
    save_plan(status){
      this.finish = true;

      let data = {
        customer_no: this.customer_no_dialog,
        customer_name : this.customer_name_dialog,
        year: this.selectedYear.toString(),
        day: this.selectedDay.toString(),
        postpone: this.postpone,
        jan: "",
        feb: "",
        mar: "",
        apr: "",
        may: "",
        jun: "",
        jul: "",
        aug: "",
        sep: "",
        oct: "",
        nov: "",
        dec: "",
      }

      this.datalist_plan.forEach((element => {
        if(element.month == "Jan"){
          data.jan = new Date(element.date).toJSON()
        }else if(element.month == "Feb"){
          data.feb = new Date(element.date).toJSON()
        }else if(element.month == "Mar"){
          data.mar = new Date(element.date).toJSON()
        }else if(element.month == "Apr"){
          data.apr = new Date(element.date).toJSON()
        }else if(element.month == "May"){
          data.may = new Date(element.date).toJSON()
        }else if(element.month == "Jun"){
          data.jun = new Date(element.date).toJSON()
        }else if(element.month == "Jul"){
          data.jul = new Date(element.date).toJSON()
        }else if(element.month == "Aug"){
          data.aug = new Date(element.date).toJSON()
        }else if(element.month == "Sep"){
          data.sep = new Date(element.date).toJSON()
        }else if(element.month == "Oct"){
          data.oct = new Date(element.date).toJSON()
        }else if(element.month == "Nov"){
          data.nov = new Date(element.date).toJSON()
        }else if(element.month == "Dec"){
          data.dec = new Date(element.date).toJSON()
        }
      }))

      // console.log(status , data)

      let headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .put(process.env.VUE_APP_API + "/customer/editdue?types="+status + "&biz_id="+this.biz_id, data , headers)
        .then((response) => {
          this.finish = true;
          if(response.status == 200){
            Swal.fire({
              icon: "success",
              title: "บันทึกการแก้ไขข้อมูลเรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 2000,
            });

            this.dialog_plan_billing = false
            this.dialog_plan_payment = false
          }
        })
        .catch((error) => {
          if(error){
            this.finish = true;
            Swal.fire({
              icon: "error",
              title: "ไม่สามารถบันทึกข้อมูลได้",
              text: "เนื่องจาก"+" "+error.response.data.msg,
              showConfirmButton: false,
              timer: 4000,
            });
          }
        });

    },
    Init() {
      var headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .get(
          process.env.VUE_APP_API +
            "/customer/info?size=" +
            this.count +
            "&page=" +
            this.page +
            "&search=" +
            String(this.search) +
            "&biz_id="+this.biz_id,
          headers
        )
        .then((response) => {
          this.finish = true;
          this.datalist = response.data.data;
          this.count = response.data.count;
          this.count_page = response.data.count_page;
          this.total_page = response.data.total;
          this.datalist.forEach((element) => {
            element["other"] = "close";
            element["remark"] = "";
            //this.customer_name_list.push(element.customer_name)

          });
          for (let index = 0; index < this.datalist.length; index++) {
            for (
              let h = 0;
              h < this.datalist[index].billing_document.length;
              h++
            ) {
              var add_remark = this.datalist[index].billing_document[h];
              if (
                add_remark != "PO" &&
                add_remark != "สัญญา" &&
                add_remark != "QT" &&
                add_remark != "Report" &&
                add_remark != "อื่นๆ"
              ) {
                this.datalist[index].other = "open";

                this.datalist[index].remark = add_remark;
              }
            }
          }
          if (response.data.count == 0) {
            this.refreshData_0();
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.clear();
            this.$router.push("/login");
          }
        });
    },
    open_contact(item_row) {
      this.finish = false;
      this.datalist_contact = [];
      this.con_cus_no = '';
      this.con_cus_no = item_row.customer_no;
      this.con_cus_name = '';
      this.con_cus_name = item_row.customer_name;
      let headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .get(
          process.env.VUE_APP_API +"/customer/contact?cus_no=" +item_row.customer_no + "&biz_id="+this.biz_id,headers
        )
        .then((response) => {
          this.finish = true;
          // console.log(response.data.data)
          let data = response.data.data;
          if(data == ""){
            this.datalist_contact = [
              {
                contact_type : 'ผู้รับวางบิล',
                contact_name : '',
                contact_tel : '',
                contact_email : '',
                contact_remark : '',
              },
              {
                contact_type : 'ผู้รับใบเสร็จ',
                contact_name : '',
                contact_tel : '',
                contact_email : '',
                contact_remark : '',
              },
              {
                contact_type : 'ผู้ติดต่อทวงหนี้',
                contact_name : '',
                contact_tel : '',
                contact_email : '',
                contact_remark : '',
              },
              {
                contact_type : 'ติดตามเอกสาร WHT',
                contact_name : '',
                contact_tel : '',
                contact_email : '',
                contact_remark : '',
              },
              {
                contact_type : 'สอบถามการชำระ',
                contact_name : '',
                contact_tel : '',
                contact_email : '',
                contact_remark : '',
              },
              {
                contact_type : 'อื่นๆ',
                contact_name : '',
                contact_tel : '',
                contact_email : '',
                contact_remark : '',
              },
            ];
          }else{
            this.datalist_contact = [
              //ผู้รับวางบิล
              {
                contact_type : 'ผู้รับวางบิล',
                contact_name : data[0].contact_the_bill_recipient,
                contact_tel : data[0].tel_bill_recipient,
                contact_email : data[0].email_of_billing_recipient,
                contact_remark : data[0].remark_the_bill_recipient,
              },
              //ผู้รับใบเสร็จ
              {
                contact_type : 'ผู้รับใบเสร็จ',
                contact_name : data[0].contact_the_recipient_of_the_receipt,
                contact_tel : data[0].tel_receipt_recipient,
                contact_email : data[0].email_of_receipt_recipient,
                contact_remark : data[0].remark_the_recipient_of_the_receipt,
              },
              //ผู้ติดต่อทวงหนี้
              {
                contact_type : 'ผู้ติดต่อทวงหนี้',
                contact_name : data[0].contact_debt_collection_contact,
                contact_tel : data[0].tel_debt_collection_contact,
                contact_email : data[0].email_debt_collector_contact,
                contact_remark : data[0].remark_debt_collector_contact,
              },
              //ผู้ติดตาม WHT
              {
                contact_type : 'ติดตามเอกสาร WHT',
                contact_name : data[0].contact_wht_follower,
                contact_tel : data[0].tel_wht_follower,
                contact_email : data[0].email_wht_follower,
                contact_remark : data[0].remark_wht_follower,
              },
              //สอบถามการชำระ
              {
                contact_type : 'สอบถามการชำระ',
                contact_name : data[0].contact_to_inquire_about_payment,
                contact_tel : data[0].tel_payment_inquirie,
                contact_email : data[0].email_inquiring_about_payment,
                contact_remark : data[0].remark_payment_inquirie,
              },
              //อื่นๆ
              {
                contact_type : 'อื่นๆ',
                contact_name : data[0].contacts_other,
                contact_tel : data[0].tel_other,
                contact_email : data[0].email_other,
                contact_remark : data[0].remark_other,
              },
            ];
            
          }
          
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.finish = true;
            this.$router.push("/login");
          }
        });
    },
    save_contact(){
      this.finish = false;
      var data = {
        // ผู้รับวางบิล
        type_bill_recipient : this.datalist_contact[0].contact_type,
        contact_the_bill_recipient : this.datalist_contact[0].contact_name,
        tel_bill_recipient : this.datalist_contact[0].contact_tel,
        email_of_billing_recipient : this.datalist_contact[0].contact_email,
        remark_the_bill_recipient : this.datalist_contact[0].contact_remark,

        // ผู้รับใบเสร็จ
        type_recipient_of_receipt : this.datalist_contact[1].contact_type,
        contact_the_recipient_of_the_receipt : this.datalist_contact[1].contact_name,
        tel_receipt_recipient : this.datalist_contact[1].contact_tel,
        email_of_receipt_recipient : this.datalist_contact[1].contact_email,
        remark_the_recipient_of_the_receipt : this.datalist_contact[1].contact_remark,

        // ผู้ติดต่อทวงหนี้
        type_debt_collector_contact : this.datalist_contact[2].contact_type,
        contact_debt_collection_contact : this.datalist_contact[2].contact_name,
        tel_debt_collection_contact : this.datalist_contact[2].contact_tel,
        email_debt_collector_contact : this.datalist_contact[2].contact_email,
        remark_debt_collector_contact : this.datalist_contact[2].contact_remark,

        // ผู้ติดตาม WHT
        type_wht_follower : this.datalist_contact[3].contact_type,
        contact_wht_follower : this.datalist_contact[3].contact_name,
        tel_wht_follower : this.datalist_contact[3].contact_tel,
        email_wht_follower : this.datalist_contact[3].contact_email,
        remark_wht_follower : this.datalist_contact[3].contact_remark,

        // สอบถามการชำระ
        type_payment_inquiry : this.datalist_contact[4].contact_type,
        contact_to_inquire_about_payment : this.datalist_contact[4].contact_name,
        tel_payment_inquirie : this.datalist_contact[4].contact_tel,
        email_inquiring_about_payment : this.datalist_contact[4].contact_email,
        remark_payment_inquirie : this.datalist_contact[4].contact_remark,

        // อื่นๆ
        type_other : this.datalist_contact[5].contact_type,
        contacts_other : this.datalist_contact[5].contact_name,
        tel_other : this.datalist_contact[5].contact_tel,
        email_other : this.datalist_contact[5].contact_email,
        remark_other : this.datalist_contact[5].contact_remark,
      }

      // console.log(data)
      let headers = {
            headers: {
              Authorization:
                "Bearer " +
                localStorage.getItem("acces_token") +
                "," +
                localStorage.getItem("secret"),
            },
          };

      this.axios
        .put(process.env.VUE_APP_API + "/customer/editcontact?cus_no="+this.con_cus_no + "&customer_name="+this.con_cus_name + "&biz_id="+this.biz_id, data , headers)
        .then((response) => {
                if(response.status == 200){
                  this.finish = true;
                  Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                }
              })
              .catch((error) => {
                this.finish = true;
                if(error){
                  Swal.fire({
                    icon: "error",
                    title: "ไม่สามารถบันทึกข้อมูลได้",
                    showConfirmButton: false,
                    timer: 4000,
                  });
                }
              });

      this.dialog_contact = false;
    },
    refreshData_0() {
      this.page = 1;
      if (this.total_page < 50) {
        this.count = 50;
        this.item_per_page_count = 50;
      } else {
        this.count = this.item_per_page_count;
      }
      var headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .get(
          process.env.VUE_APP_API +
            "/customer/info?size=" +
            this.count +
            "&page=" +
            this.page +
            "&search=" +
            String(this.search) +
            "&biz_id="+this.biz_id,
          headers
        )
        .then((response) => {
          this.finish = true;
          this.datalist = response.data.data;
          this.count = response.data.count;
          this.item_per_page_count = response.data.count;
          this.count_page = response.data.count_page;
          this.total_page = response.data.total;
          for (let index = 0; index < this.datalist.length; index++) {
            this.datalist[index]["check"] = false;
            this.datalist[index]["other"] = true;
            this.datalist[index]["remark"] = "";
          }

          if (this.page == response.data.count_page) {
            if (this.datalist.length > 0 && this.datalist.length < 50) {
              this.item_per_page_count = 50;
            } else if (
              this.datalist.length > 50 &&
              this.datalist.length < 100
            ) {
              this.item_per_page_count = 100;
            } else if (
              this.datalist.length > 100 &&
              this.datalist.length < 300
            ) {
              this.item_per_page_count = 300;
            } else if (
              this.datalist.length > 300 &&
              this.datalist.length < 500
            ) {
              this.item_per_page_count = 500;
            }
          }
          if (this.total_page == 0) {
            this.item_per_page_count = 50;
          }
        });
    },
    Export_AllFile() {
      this.finish = true;
      let headers = {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization:
              "Bearer " +
              localStorage.getItem("acces_token") +
              "," +
              localStorage.getItem("secret"),
          },
          responseType: "blob",
        };
        
        this.axios
          .get(process.env.VUE_APP_API + "/export/customer?biz_id="+this.biz_id, headers)
          .then((response) => {
            if (response.data) {
              const fileURL = window.URL.createObjectURL(response.data);
              const fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "export_customer_all.csv");
              document.body.appendChild(fileLink);
              fileLink.click();
            }
        })
    },
    item_per_page() {
      this.finish = false;
      this.count = this.item_per_page_count;
      this.page = 1;
      this.Init();
    },
    pageChange() {
      this.finish = false;
      if (
        this.page == this.count_page &&
        this.total_page < this.item_per_page_count
      ) {
        this.page = 1;
        this.Init();
      } else {
        if (this.page != this.count_page) {
          this.count = this.item_per_page_count;
        }
        this.Init();
      }
    },
    searchWord() {
      this.finish = false;
      this.count = this.item_per_page_count;
      this.Init();
    },
    // filter finance
    getFinance(){
     
      let headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };
      this.axios
        .get(
          process.env.VUE_APP_API +"/customer/list?biz_id="+this.biz_id,headers
        )
        .then((response) => {
          for (let index = 0; index < response.data.length; index++) {
              this.emptyFinance.push(response.data[index].financial_name);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.clear();
            this.$router.push("/login");
          }
        });
    },
    refreshData() {
      this.finish = false;
      this.Init();
    },
    convert_digit(data) {
      var number = Number(data).toLocaleString();
      return number;
    },
    updateCustomer_document(item) {
      var sortt = this.archive_list;
      item.billing_document.sort(function (a, b) {
        return sortt.indexOf(a) - sortt.indexOf(b);
      });
      var find_other = false;

      if (item.billing_document == null) {
        item.billing_document = [];
      }
      find_other = item.billing_document.includes("อื่นๆ");

      if (find_other == false) {
        item.other = "close";
        item.remark = "";
        this.updateCustomer(item);
      } else if (find_other == true && item.remark == "") {
        alert("กรุณาระบุข้อมูล อื่นๆ");
        item.other = "open";
      } else {
        this.updateCustomer(item);
      }
    },
    remark_text(item) {
      if (item.other == "close") {
        item.remark = "";
        for (let index = 0; index < item.billing_document.length; index++) {
          var check_item = item.billing_document[index];
          if (
            check_item != "PO" &&
            check_item != "สัญญา" &&
            check_item != "QT" &&
            check_item != "Report"
          ) {
            item.billing_document.splice(index, 1);
          }
        }
        this.updateCustomer(item);
      } else {
        if (item.remark != "") {
          item.billing_document.push(item.remark);
          this.updateCustomer(item);
        } else {
          var find_remark = item.billing_document.indexOf("");
          item.billing_document.splice(find_remark, 1);
          this.updateCustomer(item);
        }
      }
    },
    updateCustomer(item) {
      this.finish = false;
      var find_other = false;
      if (item.billing_document == null) {
        item.billing_document = [];
      }
      find_other = item.billing_document.includes("อื่นๆ");

      if (item.billing_document.length > 0 && find_other == false) {
        item.other = "close";
        item.remark = "";
        for (let index = 0; index < item.billing_document.length; index++) {
          var check_item = item.billing_document[index];
          if (
            check_item != "PO" &&
            check_item != "สัญญา" &&
            check_item != "QT" &&
            check_item != "Report"
          ) {
            item.billing_document.splice(index, 1);
          }
        }
      } else if (find_other == true && item.remark == "") {
        var find_index = item.billing_document.indexOf("อื่นๆ");
        item.billing_document.splice(find_index, 1);
        item.other = "close";
        for (let index = 0; index < item.billing_document.length; index++) {
          var check_item_1 = item.billing_document[index];
          if (
            check_item_1 != "PO" &&
            check_item_1 != "สัญญา" &&
            check_item_1 != "QT" &&
            check_item_1 != "Report"
          ) {
            item.billing_document.splice(index, 1);
          }
        }
      }

      var count = {};
      item.billing_document.forEach(function (i) {
        count[i] = (count[i] || 0) + 1;
      });
      if (count["อื่นๆ"] > 1) {
        var find_index_2 = item.billing_document.indexOf("อื่นๆ");
        item.billing_document.splice(find_index_2, 1);

        if (item.remark == "") {
          item.other = "close";
          for (let index = 0; index < item.billing_document.length; index++) {
            var check_remark_2 = item.billing_document[index];
            if (
              check_remark_2 != "PO" &&
              check_remark_2 != "สัญญา" &&
              check_remark_2 != "QT" &&
              check_remark_2 != "Report" &&
              check_remark_2 != "อื่นๆ"
            ) {
              item.billing_document.splice(index, 1);
            }
          }
        }
      }
      var update = {
        active: item.active,
        billing_contact: item.billing_contact,
        billing_document: item.billing_document,
        billing_due: item.billing_due,
        billing_type: item.billing_type,
        billing_checking: item.billing_checking,
        billing_after_checking: item.billing_after_checking,
        credit_name: item.credit_name,
        customer_name: item.customer_name,
        customer_no: item.customer_no,
        email: item.email,
        financial_name: item.financial_name,
        // online_payment: String(item.online_payment),
        online_payment: item.online_payment,
        payment_contact: item.payment_contact,
        payment_due: item.payment_due,
        payment_type: item.payment_type,
        status_customer: item.status_customer,
        customer_criteria: item.customer_criteria,
        uid: item.uid,
      };
      // this.finish = true;
      var headers = {
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .put(
          process.env.VUE_APP_API + "/customer/edit?biz_id="+this.biz_id,
          update,
          headers
        )
        .then((response) => {
          if (response) {
            this.finish = true;
          }
        })
        .catch((error) => {
          if (error) {
            Swal.fire({
              icon: "error",
              title: "ข้อมูลไม่ตรงเงื่อนไขในการเปลี่ยนแปลง",
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              this.Init();
            });
            // this.finish = true;
          }
        });
    },
  },

}
</script>

<style lang="scss" >
@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Medium.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}
.container {
  // width: 100% !important;
  font-family: "Bai_Jamjuree" !important;
  background-color: rgb(250, 250, 250);
}
.v-card-title {
  font-family: "Bai_Jamjuree" !important;
}

@media (min-width: 960px) {
  .container {
    max-width: 100%;
    background-color: rgb(250, 250, 250);
  }
}
.v-autocomplete input {
  font-size: 12px !important;
}
.v-select__selection {
  font-size: 12px !important;
}
.v-list-item__title {
  align-self: center;
  font-size: 12px;
}

.font_style {
  font-family: "Bai_Jamjuree" !important;
}
#customer-manage {
  .v-application--is-ltr .v-text-field .v-label {
    transform-origin: top left;
    font-size: 12px !important;
  }
  .v-input--selection-controls .v-input__slot > .v-label,
  .v-input--selection-controls .v-radio > .v-label {
    font-size: 14px;
  }
  .v-chip .v-chip__content {
    align-items: center;
    display: inline-flex;
    height: 100%;
    max-width: 100%;
    margin: auto;
  }
  .table-sum-cus {
    width: 100% !important;
    overflow: auto !important;
    table {
      border-spacing: 0;
      position: relative;
      border-collapse: collapse;
    }
    thead th:first-child {
      left: 0;
      padding-left: 20px !important;
      z-index: 100 !important;
      border-right: none !important;
      background: linear-gradient(
        90deg,
        #FFF6CC 99.3%,
        #ABAFAB 100%
      ) !important;
    }
    tbody td:first-child {
      left: 0;
      // border-right: none;
      z-index: 99 !important;
      background: linear-gradient(
        90deg,
        rgba(253, 253, 253, 1) 99.3%,
        #ABAFAB 100%
      ) !important;
      position: -webkit-sticky; /* for Safari */
      position: sticky;
      left: 0;
      background: #fff;
    }
    tbody th {
      position: -webkit-sticky; /* for Safari */
      position: sticky;
      left: 0;
    }
    b-textarea {
      resize: none;
      overflow: hidden !important;
      font-size: 13px;
      height: auto;
      border-radius: 0px;
      width: 98%;
    }
    textarea {
      overflow: hidden !important;
      width: 98%;
      margin: auto;
      border-radius: 0px;
    }
  }

  .table_in_sum_customer {
    background-position: center !important;
    background-repeat: no-repeat !important;
    font-family: "Bai_Jamjuree" !important;
    z-index: 10 !important;
    overflow: auto !important;
    text-align: center;

    .v-data-table--fixed-header
      > .v-data-table__wrapper
      > table
      > thead
      > tr
      > th {
      border-bottom: 1px solid !important;
    }

    td.td_sub_value {
      padding: 0;
      border-right: 1px solid #ABAFAB;
      width: 340px;
      vertical-align: middle;
    }
    td {
      font-size: 12px !important;
      background-color: white !important;
    }
  }

  .v-select__slot {
    position: relative;
    align-items: center;
    display: flex;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    min-height: 48px !important;
    height: 100% !important;
    border-radius: 0px !important;
    margin-top: 10px;
    border: none;
  }
}

.v-autocomplete__content .v-list__tile {
  height: auto;
}
.border-frame {
  border: 1px solid #ABAFAB;
}
.border-frame-header {
  justify-items: center;
  align-items: center;
  border: 1px solid #ABAFAB;
}

.font-text-alert {
  font-family: "Bai_Jamjuree" !important;
}
.v-pagination {
  justify-content: right !important;
}
.swal2-title {
  position: relative;
  font-family: "Bai_Jamjuree" !important;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}
button.v-btn[disabled] {
  opacity: 0.6;
}
.text-h5 {
  font-family: "Bai_Jamjuree" !important;
}
.font-text {
  font-family: "Bai_Jamjuree" !important;
}
.style-chooser {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 1px;
  width: 100%;
  height: 45px;
  padding-left: 7px;
  cursor: pointer;
}
td.filter-manage {
  padding:0;border-right:1px solid #ABAFAB;
  vertical-align: middle;
  text-align:left;
  padding-left:10px;
  color: blue;
}
.fixed-detail {
  width: 400px;
  position: sticky !important;
  top: auto !important;
  z-index: 1 !important;
  background-color: white;
  // border-right: 1px solid #cccccc;
  background: linear-gradient(
    90deg,
    rgba(253, 253, 253, 1) 99%,
    rgba(101, 101, 101, 1) 100%
  ) !important;
}
.cover-table {
  width: 100%;
  overflow: auto;
  font-family: "Bai_Jamjuree" !important;
}
.table-invoice {
  width: 100%;
  overflow: auto;
  word-break: break-all;
}
th.text-start.invoice1.sortable {
  position: sticky !important;
  left: 0px !important;
  z-index: 5 !important;
  padding-top: 14px;
  background: linear-gradient(
    90deg,
    #ececec 99%,
    rgba(101, 101, 101, 1) 100%
  ) !important;
}
th.text-left.invoice1_modal.sortable {
  position: sticky;
  left: 56px !important;
  z-index: 10 !important;
  padding-top: 14px;
  // border-right: 1px solid #cccccc;
  // background-color: rgb(168, 255, 214) !important;
  background: linear-gradient(
    90deg,
    #ececec 99%,
    rgba(101, 101, 101, 1) 100%
  ) !important;
}
.table_in_book1 {
  background-position: center;
  background-repeat: no-repeat;
  font-family: "Bai_Jamjuree" !important;
  z-index: 10 !important;
}
#invoice_book_1 {
  th.text-start {
    background-color: #ececec !important;
  }
  th.text-center {
    background-color: #ececec !important;
  }
  th.text-left {
    background-color: #ececec !important;
  }
  tbody {
    td.text-left {
      word-break: break-all;
    }
    td.text-start {
      font-size: 14px;
      position: sticky !important;
      left: 0px !important;
      top: auto;
      z-index: 2 !important;
      background-color: white;
      // border-right: 1px solid #cccccc;
      background: linear-gradient(
        90deg,
        rgba(253, 253, 253, 1) 99%,
        rgba(101, 101, 101, 1) 100%
      ) !important;
    }

    td.text-center.fixed {
      font-size: 14px;
      position: sticky !important;
      left: 0px !important;
      top: auto !important;
      z-index: 2 !important;
    }
    td:not(.fixed) {
      font-size: 14px;
      z-index: 0;
    }

    td.text-start:first-child {
      font-size: 14px;
      //   position: sticky;
      width: 20px !important;
      left: 0px !important;
      border-right: none !important;
      background: linear-gradient(
        90deg,
        rgba(253, 253, 253, 1) 99%,
        rgba(101, 101, 101, 1) 100%
      ) !important;
    }
  }
}
// ======================================loading..==============================================//
.loading-waiting {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: #ecf5ff62;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
}

.load-4 .ring-1 {
  animation: loadingD 1.5s 0.3s cubic-bezier(0.17, 0.37, 0.43, 0.67) infinite;
}

@keyframes loadingD {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ring-1 {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  padding: 7px;
  border: 8px dashed #4b9cdb;
  border-radius: 100%;
}

.load-6 .letter {
  animation-name: loadingF;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
  animation-direction: linear;
}

.letter-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b9cdb;
  font-size: 20px;
}

.l-1 {
  animation-delay: 0.48s;
}

.l-2 {
  animation-delay: 0.6s;
}

.l-3 {
  animation-delay: 0.72s;
}

.l-4 {
  animation-delay: 0.1s;
}

.l-5 {
  animation-delay: 0.96s;
}

.l-6 {
  animation-delay: 1.08s;
}

.l-7 {
  animation-delay: 1.2s;
}

.l-8 {
  animation-delay: 1.32s;
}

.l-9 {
  animation-delay: 1.44s;
}

.l-10 {
  animation-delay: 1.56s;
}

@keyframes loadingF {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
// ======================================End loading..==========================================//
</style>